import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageProvider.tsx';
import { ThemeContextProvider } from './contexts/ThemeProvider.tsx';
import { HeaderProvider } from './contexts/HeaderContext.tsx';
import { AppUserProvider } from './contexts/AppUserProvider.tsx'; // Import the new provider
import { ContentSpaceProvider } from './contexts/ContentSpaceContext.tsx';
import { MobileRecordingProvider } from './contexts/MobileRecordingContext.tsx';
import { HelpDrawerProvider } from './contexts/HelpDrawerContext.tsx';
import { ToastProvider } from './components/Toast';
import { ScrollToTop } from './components/ScrollToTop';
import { ErrorBoundary } from './components/ErrorBoundary';
// Temporarily disabled due to vite-plugin-pwa compatibility issues
// import { registerSW } from 'virtual:pwa-register';

// Register service worker for PWA functionality
// const updateSW = registerSW({
//   onNeedRefresh() {
//     if (confirm('New content available. Reload to update?')) {
//       updateSW(true);
//     }
//   },
//   onOfflineReady() {
//     console.log('App ready to work offline');
//   },
// });

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
  <Router>
    <ScrollToTop />
    <LanguageProvider>
      <ThemeContextProvider>
        <Auth0Provider
          domain={import.meta.env.VITE_APP_AUTHZERO_DOMAIN}
          clientId={import.meta.env.VITE_APP_AUTHZERO_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            // Request scopes needed for user profile information like externalId (sub), email, name etc.
            // Common OIDC scopes: openid profile email
            audience:
              import.meta.env.VITE_API_AUTH0_AUDIENCE ||
              import.meta.env.VITE_APP_AUTHZERO_AUDIENCE,
            scope: 'openid profile email offline_access'
          }}
          cacheLocation="localstorage"
          useRefreshTokens
          onRedirectCallback={(appState) => {
            // If appState has a returnTo, navigate there
            // Otherwise, strip auth query params and stay on current path
            if (appState?.returnTo) {
              window.location.href = appState.returnTo;
            } else {
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname
              );
            }
          }}
        >
          <AppUserProvider>
            <HeaderProvider>
              <HelpDrawerProvider>
                <ContentSpaceProvider>
                  <MobileRecordingProvider>
                    <ToastProvider>
                      <App />
                    </ToastProvider>
                  </MobileRecordingProvider>
                </ContentSpaceProvider>
              </HelpDrawerProvider>
            </HeaderProvider>
          </AppUserProvider>
        </Auth0Provider>
      </ThemeContextProvider>
    </LanguageProvider>
  </Router>
  </ErrorBoundary>
);
